export default __webpack_public_path__ + "static/media/transener.edb83087.jpg";